import { IMelodyTableData, IRhytNameData, ITonesetStaffData, TonesetText } from "./types";

const bars = [
    null,
    {
        notes: [
            {
                l: 4,
                p: {
                    s: 5,
                    a: 0,
                    o: 0,
                },
            },
            {
                l: 4,
                p: {
                    s: 5,
                    a: 0,
                    o: 0,
                },
            },
            {
                l: 2,
                p: {
                    s: 5,
                    a: 0,
                    o: 0,
                },
            },
        ],
    },
    {
        notes: [
            {
                l: 4,
                p: {
                    s: 5,
                    a: 0,
                    o: 0,
                },
            },
            {
                l: 4,
                p: {
                    s: 5,
                    a: 0,
                    o: 0,
                },
            },
            {
                l: 2,
                p: {
                    s: 5,
                    a: 0,
                    o: 0,
                },
            },
        ],
    },
    {
        notes: [
            {
                l: 4,
                p: {
                    s: 5,
                    a: 0,
                    o: 0,
                },
            },
            {
                l: 4,
                p: {
                    s: 2,
                    a: 0,
                    o: 0,
                },
            },
            {
                l: 4,
                d: 1,
                p: {
                    s: 1,
                    a: 0,
                    o: 0,
                },
            },
            {
                l: 8,
                p: {
                    s: 3,
                    a: 0,
                    o: 0,
                },
            },
        ],
    },
    {
        notes: [
            {
                l: 1,
                p: {
                    s: 5,
                    a: 0,
                    o: 0,
                },
            },
        ],
    },
    {
        notes: [],
    },
];

const doPos = {
    i: -1,
    o: 4,
};

export const rhythmTask = {
    type: "rhytSorting",
    data: {
        boxes: [["ta", "ta", "ta-a"], ["ta", "ta", "ta-a"], ["ta", "ta", "tam", "ti"], ["ta-a-a-a"]],
        tempo: 206,
        scale: 1.45,
        color: "00AAA4",
    },
};

export const melodyTask = {
    type: "melodyTable",
    data: {
        score: {
            barlines: [],
            signatures: [
                {
                    bar: 1,
                    num: 4,
                    den: 4,
                },
            ],
            bars,
            doPos,
            settings: {
                staffDistance: 130,
                staffLines: true,
                stick: false,
                e16: true,
                upperText: 1,
            },
        },
        size: {
            x: 53,
            y: 92,
        },
        position: 30,
        submit: {
            x: 586.915688367129,
            y: 640.1921024546425,
        },
        tempo: 206,
        hint: true,
        color: "00AAA4",
    } as IMelodyTableData,
};

export const solfaNameTask = {
    type: "solfaName",
    data: {
        score: {
            barlines: [],
            signatures: [
                {
                    bar: 1,
                    num: 4,
                    den: 4,
                },
            ],
            bars,
            doPos,
            settings: {
                staffDistance: 130,
                staffLines: true,
                stick: false,
                e16: true,
                upperText: 1,
            },
        },
        tempo: 206,
        scale: 1.5,
        color: "00AAA4",
        hint: true,
    },
};

export const tonesetStaffTask = {
    type: "tonesetStaff",
    data: {
        score: {
            ...solfaNameTask.data.score,
            settings: {
                ...solfaNameTask.data.score.settings,
                colors: true,
            },
        },
        tempo: 80,
        size: {
            y: 89,
        },
        position: 0,
        method: TonesetText.Solfa,
        color: "",
    } as ITonesetStaffData
}

export const singingTask = {
    data: {
        ...solfaNameTask.data,
        score: {
            ...solfaNameTask.data.score,
            settings: {
                ...solfaNameTask.data.score.settings,
                upperText: 0,
            },
        },
    },
    type: "singing",
};

export const barlineTask = {
    data: {
        ...singingTask.data,
        score: {
            ...solfaNameTask.data.score,
            settings: {
                ...solfaNameTask.data.score.settings,
                noteDistance: 0.93,
            },
        },
    },
    type: "barline",
};


export const pianoTask = {
    ...solfaNameTask,
    type: "piano",
};

export const handSignTask = {
    ...solfaNameTask,
    type: "handSign",
    data: {
        ...solfaNameTask.data,
        score: {
            ...solfaNameTask.data.score,
            settings: {
                ...solfaNameTask.data.score.settings,
                colors: true,
                notehead: "handsign",
            },
        },
    },
};

export const barSortingTask = {
    type: "barSorting2",
    data: {
        score: {
            ...melodyTask.data.score,
            settings: {
                staffDistance: 130,
                staffLines: true,
                stick: false,
                e16: true,
                upperText: 0,
            },
        },
        color: "00AAA4",
        scale: 1.51,
        tempo: 206,
    },
};

export const rhytNameTask = {
    type: "rhytName",
    id: 1,
    data: {
        tempo: 206,
        scale: 1.6,
        score: {
            barlines: [],
            signatures: [{ bar: 1, num: 4, den: 4 }],
            bars: [
                null,
                { notes: [{ l: 4 }, { l: 4 }, { l: 2 }] },
                { notes: [{ l: 4 }, { l: 4 }, { l: 2 }] },
                { notes: [{ l: 4 }, { l: 4 }, { l: 4, d: 1 }, { l: 8 }] },
                { notes: [{ l: 1 }] },
                { notes: [] },
            ],
            doPos: { i: 0, o: 4 },
            settings: {
                staffDistance: 130,
                staffLines: false,
                stick: true,
                e16: true,
                upperText: 2,
            },
        },
        hint: true
    } as IRhytNameData,
};

export const rhytNotationTask = {
    type: "rhytNotation",
    data: {
        tempo: 206,
        scale: 1.6,
        score: {
            barlines: [],
            signatures: [{ bar: 1, num: 4, den: 4 }],
            bars: [
                null,
                { notes: [{ l: 4 }, { l: 4 }, { l: 2 }] },
                { notes: [{ l: 4 }, { l: 4 }, { l: 2 }] },
                { notes: [{ l: 4 }, { l: 4 }, { l: 4, d: 1 }, { l: 8 }] },
                { notes: [{ l: 1 }] },
                { notes: [] },
            ],
            doPos: { i: 0, o: 4 },
            settings: {
                staffDistance: 130,
                staffLines: false,
                stick: true,
                e16: true,
                upperText: 2,
            },
        },
        hint: true,
    },
};

export const rhytKnockTask = {
    type: "rhytKnock",
    data: rhytNotationTask.data,
};

const flowScore1 = {
    barlines: [],
    signatures: [
        {
            bar: 1,
            num: 4,
            den: 4,
            noden: true,
        },
    ],
    bars,
    doPos,
    doClef: true,
    doClefOffset: [-1],
    settings: {
        staffDistance: 130,
        staffLines: true,
        stick: false,
        e16: true,
        upperText: 1,
        lines: 3,
        colors: true,
        noStem: true,
    },
};

const flowScore3 = {
    ...flowScore1,
    doClef: false,
    settings: {
        ...flowScore1.settings,
        lines: 5,
        noStem: false,
    },
};

const flowScore2 = {
    barlines: [],
    doClef: true,
    doClefOffset: [-1],
    signatures: [
        {
            bar: 1,
            num: 4,
            den: 4,
            noden: true,
        },
    ],
    bars: [
        null,
        {
            notes: [
                {
                    l: 4,
                    p: {
                        s: 0,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 0,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    d: 1,
                    p: {
                        s: 0,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 8,
                    p: {
                        s: 0,
                        a: 0,
                        o: 0,
                    },
                },
            ],
        },
        {
            notes: [
                {
                    l: 4,
                    p: {
                        s: 0,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 5,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 5,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 8,
                    p: {
                        s: 5,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 8,
                    p: {
                        s: 5,
                        a: 0,
                        o: 0,
                    },
                },
            ],
        },
        {
            notes: [
                {
                    l: 4,
                    p: {
                        s: 5,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 3,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 3,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 5,
                        a: 0,
                        o: 0,
                    },
                },
            ],
        },
        {
            notes: [
                {
                    l: 1,
                    p: {
                        s: 3,
                        a: 0,
                        o: 0,
                    },
                },
            ],
        },
        {
            notes: [],
        },
    ],
    doPos,
    settings: {
        staffDistance: 130,
        staffLines: true,
        stick: false,
        e16: true,
        upperText: 0,
        lines: 3,
        noNotehead: true,
        notehead: "solfa",
    },
};

const flowScore4 = {
    barlines: [
        {
            bar: 4,
            type: "double",
        },
    ],
    signatures: [
        {
            bar: 1,
            num: 4,
            den: 4,
            noden: true,
        },
    ],
    bars: [
        null,
        {
            notes: [
                {
                    l: 4,
                    p: {
                        s: 0,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 0,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    d: 1,
                    p: {
                        s: 0,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 8,
                    p: {
                        s: 0,
                        a: 0,
                        o: 0,
                    },
                },
            ],
        },
        {
            notes: [
                {
                    l: 4,
                    p: {
                        s: 0,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 5,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 5,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 8,
                    p: {
                        s: 5,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 8,
                    p: {
                        s: 5,
                        a: 0,
                        o: 0,
                    },
                },
            ],
        },
        {
            notes: [
                {
                    l: 4,
                    p: {
                        s: 2,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 2,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 0,
                        a: 0,
                        o: 0,
                    },
                },
                {
                    l: 4,
                    p: {
                        s: 3,
                        a: 0,
                        o: 0,
                    },
                },
            ],
        },
        {
            notes: [
                {
                    l: 1,
                    p: {
                        s: 1,
                        a: 0,
                        o: 0,
                    },
                },
            ],
        },
        {
            notes: [],
        },
    ],
    doPos,
    settings: {
        staffDistance: 130,
        staffLines: true,
        stick: false,
        e16: true,
        upperText: 1,
        colors: true,
        notehead: "number",
    },
};

export const flowTask = {
    type: "flow",
    data: {
        scores: [flowScore1, flowScore2, flowScore3, flowScore4],
        sizes: [
            {
                x: 0.8,
                y: 94,
            },
            {
                x: 0.8,
                y: 94,
            },
            {
                x: 0.8,
                y: 94,
            },
            {
                x: 0.8,
                y: 94,
            },
        ],
        scales: [1.5, 1.5, 1.5, 1.5],
        tempos: [206, 206, 206, 206],
    },
};

export const intervalsTask = {
    type: "intervals",
    data: {
        score: {
            signatures: [
                {
                    bar: 1,
                    num: 4,
                    den: 4,
                },
            ],
            bars: [
                null,
                {
                    notes: [
                        {
                            l: 1,
                            p: [
                                {
                                    s: 5,
                                },
                                {
                                    s: 1,
                                },
                            ],
                        },
                    ],
                },
                {
                    notes: [
                        {
                            l: 1,
                            p: [
                                {
                                    s: 2,
                                },
                                {
                                    s: 2,
                                    o: -1,
                                },
                            ],
                        },
                    ],
                },
                {
                    notes: [
                        {
                            l: 1,
                            p: [
                                {
                                    s: 1,
                                },
                                {
                                    s: 4,
                                    o: -1,
                                },
                            ],
                        },
                    ],
                },
                {
                    notes: [
                        {
                            l: 1,
                            p: [
                                {
                                    s: 3,
                                },
                                {
                                    s: 2,
                                    o: -1,
                                },
                            ],
                        },
                    ],
                },
                {
                    notes: [
                        {
                            l: 1,
                            p: [
                                {
                                    s: 5,
                                },
                                {
                                    s: 1,
                                },
                            ],
                        },
                    ],
                },
                {
                    notes: [],
                },
            ],
            barlines: [
                {
                    bar: 5,
                    type: "double",
                },
            ],
            doPos,
            settings: solfaNameTask.data.score.settings,
        },
        tempo: 80,
        scale: 1.57,
    },
};

export const chords3Task = {
    type: "chords3",
    data: {
        score: {
            signatures: [
                {
                    bar: 1,
                    num: 4,
                    den: 4,
                },
            ],
            bars: [
                null,
                {
                    notes: [
                        {
                            l: 1,
                            p: [
                                {
                                    s: 5,
                                },
                                {
                                    s: 6,
                                    o: -1,
                                },
                                {
                                    s: 2,
                                    o: -1,
                                },
                            ],
                        },
                    ],
                },
                {
                    notes: [
                        {
                            l: 1,
                            p: [
                                {
                                    s: 2,
                                },
                                {
                                    s: 5,
                                },
                                {
                                    s: 1,
                                },
                            ],
                        },
                    ],
                },
                {
                    notes: [
                        {
                            l: 1,
                            p: [
                                {
                                    s: 1,
                                },
                                {
                                    s: 4,
                                    o: -1,
                                },
                                {
                                    s: 5,
                                    o: -1,
                                },
                            ],
                        },
                    ],
                },
                {
                    notes: [
                        {
                            l: 1,
                            p: [
                                {
                                    s: 3,
                                },
                                {
                                    s: 6,
                                    o: -1,
                                },
                                {
                                    s: 0,
                                    o: -1,
                                },
                            ],
                        },
                    ],
                },
                {
                    notes: [
                        {
                            l: 1,
                            p: [
                                {
                                    s: 5,
                                },
                                {
                                    s: 1,
                                },
                                {
                                    s: 2,
                                    o: -1,
                                },
                            ],
                        },
                    ],
                },
                {
                    notes: [],
                },
            ],
            barlines: [
                {
                    bar: 5,
                    type: "double",
                },
            ],
            doPos,
            settings: solfaNameTask.data.score.settings,
        },
        tempo: 80,
        scale: 1.56,
    },
};


export const subScoreTask = {
    type: 'subScore',
    data: {
        hint: true,
        href: '8ewfq_mTZtg',
        endHour: null,
        endMinute: null,
        endSecond: 40,
        startHour: null,
        startMinute: null,
        startSecond: 21,
        scores: [
            {
                score: {
                    barlines: [
                        {
                            type: 'double',
                            bar: 16
                        }
                    ],
                    signatures: [
                        {
                            bar: 1,
                            num: 4,
                            den: 4
                        }
                    ],
                    bars: [
                        null,
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'Jin',
                                    h: 1
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'gle'
                                },
                                {
                                    l: 2,
                                    p: {
                                        s: 5
                                    },
                                    y: 'bells,'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'jin',
                                    h: 1
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'gle'
                                },
                                {
                                    l: 2,
                                    p: {
                                        s: 5
                                    },
                                    y: 'bells,'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'Jin',
                                    h: 1
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 2
                                    },
                                    y: 'gle'
                                },
                                {
                                    l: 4,
                                    d: 1,
                                    p: {
                                        s: 1
                                    },
                                    y: 'all'
                                },
                                {
                                    l: 8,
                                    p: {
                                        s: 3
                                    },
                                    y: 'the'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 1,
                                    p: {
                                        s: 5
                                    },
                                    y: 'way!'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 0
                                    },
                                    y: 'Oh,'
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 0
                                    },
                                    y: 'what'
                                },
                                {
                                    l: 4,
                                    d: 1,
                                    p: {
                                        s: 0
                                    },
                                    y: 'fun'
                                },
                                {
                                    l: 8,
                                    p: {
                                        s: 0
                                    },
                                    y: 'it'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 0
                                    },
                                    y: 'is'
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'to'
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'ride'
                                },
                                {
                                    l: 8,
                                    p: {
                                        s: 5
                                    },
                                    y: 'in'
                                },
                                {
                                    l: 8,
                                    p: {
                                        s: 5
                                    },
                                    y: 'a'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'one',
                                    h: 1
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 3
                                    },
                                    y: 'horse'
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 3
                                    },
                                    y: 'o',
                                    h: 1
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'pen'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 2,
                                    p: {
                                        s: 3
                                    },
                                    y: 'sleigh'
                                },
                                {
                                    l: 2,
                                    p: {
                                        s: 2
                                    },
                                    y: 'Hey!'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'Jin',
                                    h: 1
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'gle'
                                },
                                {
                                    l: 2,
                                    p: {
                                        s: 5
                                    },
                                    y: 'bells,'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'jin',
                                    h: 1
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'gle'
                                },
                                {
                                    l: 2,
                                    p: {
                                        s: 5
                                    },
                                    y: 'bells,'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'Jin',
                                    h: 1
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 2
                                    },
                                    y: 'gle'
                                },
                                {
                                    l: 4,
                                    d: 1,
                                    p: {
                                        s: 1
                                    },
                                    y: 'all'
                                },
                                {
                                    l: 8,
                                    p: {
                                        s: 3
                                    },
                                    y: 'the'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 1,
                                    p: {
                                        s: 5
                                    },
                                    y: 'way!'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 0
                                    },
                                    y: 'Oh,'
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 0
                                    },
                                    y: 'what'
                                },
                                {
                                    l: 4,
                                    d: 1,
                                    p: {
                                        s: 0
                                    },
                                    y: 'fun'
                                },
                                {
                                    l: 8,
                                    p: {
                                        s: 0
                                    },
                                    y: 'it'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 0
                                    },
                                    y: 'is'
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'to'
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 5
                                    },
                                    y: 'ride'
                                },
                                {
                                    l: 8,
                                    p: {
                                        s: 5
                                    },
                                    y: 'in'
                                },
                                {
                                    l: 8,
                                    p: {
                                        s: 5
                                    },
                                    y: 'a'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 4,
                                    p: {
                                        s: 2
                                    },
                                    y: 'one',
                                    h: 1
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 2
                                    },
                                    y: 'horse'
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 0
                                    },
                                    y: 'o',
                                    h: 1
                                },
                                {
                                    l: 4,
                                    p: {
                                        s: 3
                                    },
                                    y: 'pen'
                                }
                            ]
                        },
                        {
                            notes: [
                                {
                                    l: 1,
                                    p: {
                                        s: 1
                                    },
                                    y: 'sleigh!'
                                }
                            ]
                        },
                        {
                            notes: []
                        }
                    ],
                    doPos: {
                        i: 1,
                        o: 4
                    },
                    settings: {
                        staffDistance: 130,
                        staffLines: true,
                        stick: false,
                        e16: true,
                        upperText: 0,
                        systemDistance: 26,
                        noteDistance: 0.82,
                        lowerText: 1
                    }
                },
                scale: 0.97,
                _id: '609401fcb44172b51171d8fe',
                tempo: 60
            }
        ],
        points: [
            21.72,
            22.24,
            22.52,
            22.77,
            23.32,
            23.6,
            23.87,
            24.44,
            24.72,
            25,
            25.42,
            25.54,
            26.64,
            26.93,
            27.23,
            27.63,
            27.79,
            28.09,
            28.36,
            28.62,
            28.77,
            28.92,
            29.17,
            29.44,
            29.69,
            29.96,
            30.57,
            31.15,
            31.42,
            31.69,
            32.19,
            32.52,
            32.78,
            33.39,
            33.68,
            33.96,
            34.34,
            34.46,
            35.57,
            35.86,
            36.13,
            36.54,
            36.69,
            36.99,
            37.3,
            37.55,
            37.7,
            37.84,
            38.11,
            38.37,
            38.66,
            38.91,
            40.06,
            40.4
        ],
        opacity: 0.81
    },
    id: 1
}